import TextContent from 'components/TextContent';
import { DBConfig } from 'config';
import React from 'react';
import { connect } from 'react-redux';
import { ApplicationState, Article } from 'types';

interface Props {
	faqRecord: Article;
}

const Component = (props: Props) => {
	return (
		<div style={{ padding: 16 }}>
			<TextContent>{props.faqRecord?.text?.en}</TextContent>
		</div>
	);
};

function mapStateToProps(state: ApplicationState) {
	let faqId = state.dataState.configs.byId[DBConfig.FAQ];
	let faqRecord = state.dataState.articles.byId[faqId?.value];

	return {
		faqRecord,
	};
}

export default connect(mapStateToProps)(Component);
